import { Divider, SwipeableDrawer } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { toggleNotificationDrawer } from "../../../state/ducks/notification/operations";
import { localized } from "../../../state/i18n/i18n";
import { AppState } from "../../../state/store";
import "./notification-drawer.scss";
import NotificationList from "./notification-list";

const mapStateToProps = (state: AppState) => {
  return {
    toggle: state.notificationReducer.notificationDrawerVisible,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  toggleVisibility: () => toggleNotificationDrawer()(dispatch),
});

type Props = Partial<ReturnType<typeof mapStateToProps>> &
  Partial<ReturnType<typeof mapDispatchToProps>>;

class NotificationDrawerApp extends React.PureComponent<Props> {
  public render() {
    return (
      <div className="mobile">
        <SwipeableDrawer
          variant="temporary"
          anchor="right"
          onOpen={this.toggleDrawer()}
          onClose={this.toggleDrawer()}
          open={this.props.toggle!}
        >
          <div className="topContainer notifikationHeader notificationHeaderApp">
            <div className="notificationMainHeader">
              {localized("Notifications")}
            </div>
            <div className="notificationSubheader">
              {localized("ReceivedNotifications")}
            </div>
          </div>

          <Divider />
          <div className="notificationApp">
            <NotificationList />
          </div>
        </SwipeableDrawer>
      </div>
    );
  }

  private toggleDrawer = () => (event: React.MouseEvent | React.TouchEvent) => {
    this.props.toggleVisibility!();
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationDrawerApp);
